import { useEffect, useState } from 'react';
import { getAccessToken, getRefreshToken, isAccessTokenExpired, getUserToken } from '../token/UserToken';

const DebugAuth = () => {
  const [tokenInfo, setTokenInfo] = useState<any>(null);

  useEffect(() => {
    const updateTokenInfo = () => {
      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();
      
      if (accessToken) {
        try {
          const decoded = getUserToken(accessToken);
          setTokenInfo({
            hasAccessToken: !!accessToken,
            hasRefreshToken: !!refreshToken,
            isExpired: isAccessTokenExpired(),
            exp: new Date(decoded.exp * 1000).toLocaleString(),
            sub: decoded.sub,
            currentTime: new Date().toLocaleString()
          });
        } catch (error) {
          setTokenInfo({
            hasAccessToken: !!accessToken,
            hasRefreshToken: !!refreshToken,
            error: 'Error decoding token'
          });
        }
      } else {
        setTokenInfo({
          hasAccessToken: false,
          hasRefreshToken: !!refreshToken
        });
      }
    };

    updateTokenInfo();
    const interval = setInterval(updateTokenInfo, 300000); // Atualizar a cada 5 segundos

    return () => clearInterval(interval);
  }, []);

  if (process.env.NODE_ENV === 'production') {
    return null; // Não mostrar em produção
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <h4>Debug Auth Info:</h4>
      <pre>{JSON.stringify(tokenInfo, null, 2)}</pre>
    </div>
  );
};

export default DebugAuth;
